<script setup lang="ts">
import AppButton from '@/shared/ui/AppButton/index';
import AppTextarea from '@/shared/ui/AppTextarea/index';

import { ROLE_TYPE_LAWYER } from '@/shared/constants/roleTypeConstants';
import { useModalStore } from '@/shared/ui/AppModal/store/modal';
import { useUserStore } from '@/entities/user/store';

withDefaults(defineProps<{ error?: string }>(), { error: '' });

const emit = defineEmits<{
  (e: 'create', text: string): void;
  (e: 'reset-error'): void;
}>();

const commentValue = defineModel<string>({ default: '' });

const modalStore = useModalStore();
const userStore = useUserStore();
const { isAuth } = storeToRefs(userStore);

const isMobile: boolean = useIsMobile();

const isDisabled: ComputedRef<boolean> = computed(
  () => !commentValue.value.length || !isAuth.value,
);

const sendComment = (): void => {
  emit('create', commentValue.value);
};

const showAuthModal = (): void => {
  if (!isAuth.value) {
    modalStore.setModalState('auth', true, {
      isLogin: true,
      mode: ROLE_TYPE_LAWYER,
    });
  }
};
</script>

<template>
  <form
    :class="['article-comments-form', { _mobile: isMobile }]"
    @submit.prevent="sendComment"
  >
    <AppTextarea
      v-model="commentValue"
      class="article-comments-form__textarea"
      placeholder="Комментарий ..."
      :rows="3"
      :error="error"
      :attr="{ 'data-testid': 'article-comment-input' }"
      @focus="showAuthModal"
      @input="emit('reset-error')"
    />
    <div class="article-comments-form__button-wrapper">
      <AppButton
        class="article-comments-form__button"
        button-text="Отправить"
        type="submit"
        :disabled="isDisabled"
        is-small
      />
    </div>
  </form>
</template>

<style lang="less">
.article-comments-form {
  .flex-column(@size-x3);

  &__textarea .app-textarea__field {
    min-height: 100px;
    background-color: @color-black-haze;

    &::placeholder {
      color: @color-silver-chalice;
    }
  }

  &._mobile &__button.app-button._small {
    width: 100%;
  }
}
</style>
